// eslint-disable-next-line import/prefer-default-export
export function isUrlPointsToFile(url: string): boolean {
  try {
    const urlObj = new URL(url, 'https://test.com/');
    const pathParts = urlObj.pathname.split('.');

    if (pathParts.length < 2) {
      return false;
    }

    const extension = pathParts.pop()?.toLowerCase() || '';
    return extension.length === 3 || extension.length === 4;
  } catch {
    return false;
  }
}
